import { Layout } from '@evisort/eds/components/Layout/Layout';
import { Text } from '@evisort/eds/components/Text/Text';

interface Props {
  subtitle: string;
  title: string;
  /**
   * `compact` is used above the card on mobile, sized down so it doesn't
   * compete with the card's own heading below it. Default is the full desktop
   * marketing panel size.
   */
  variant?: 'default' | 'compact';
}

/** Headline and tagline for `AuthPageLayout`'s `marketing` slots. */
export function AuthMarketingHeader({
  subtitle,
  title,
  variant = 'default',
}: Props) {
  const isCompact = variant === 'compact';

  return (
    <Layout direction="column" spacing="s">
      <Text as="h2" variant={isCompact ? 'heading-s' : 'heading-l'}>
        {title}
      </Text>
      <Text as="p" tone="auto" variant={isCompact ? 'body-s' : 'body-l'}>
        {subtitle}
      </Text>
    </Layout>
  );
}
